import React from 'react';

import { GenericSelector } from '../GenericSelector';

export const PrioritySelector = ({
  onPriorityChange,
  priorities,
  selectedPriority,
  size = 'small'
}) => {
  return (
    <GenericSelector
      value={selectedPriority}
      onChange={onPriorityChange}
      options={priorities}
      size={size}
    />
  );
};
